import React, { useState } from 'react';
import { Plus, Clock, Users } from 'lucide-react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Button from '../../components/ui/Button';
import Modal from '../../components/ui/Modal';
import Input, { Select } from '../../components/ui/Input';
import { useToast } from '../../components/ui/Toast';
import { taskTemplates, employees } from '../../data/mockData';

const freqLabel = { daily: 'Ежедневно', weekly: 'Еженедельно', monthly: 'Ежемесячно' };
const freqColor = { daily: 'success', weekly: 'primary', monthly: 'warning' };

export default function TaskTemplates() {
  const toast = useToast();
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ name: '', type: 'osg', frequency: 'daily' });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1A1A2E' }}>Шаблоны задач</h1>
          <p style={{ color: '#8E8E93', fontSize: 13, marginTop: 2 }}>Повторяющиеся задачи с автоназначением</p>
        </div>
        <Button icon={<Plus size={14} />} onClick={() => setShowModal(true)}>Создать шаблон</Button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 16 }}>
        {taskTemplates.map(tpl => {
          const assignedEmps = employees.filter(e => tpl.assignTo.includes(e.id));
          return (
            <div key={tpl.id} style={{
              background: '#fff', borderRadius: 14, padding: 20, border: '1px solid #F0F0F0',
              boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 10 }}>
                <div>
                  <h3 style={{ fontWeight: 700, fontSize: 14, color: '#1A1A2E', marginBottom: 6 }}>{tpl.name}</h3>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    <Badge variant={tpl.type === 'osg' ? 'osg' : 'display'}>{tpl.type === 'osg' ? 'ОСГ' : 'Выкладка'}</Badge>
                    <Badge variant={freqColor[tpl.frequency]}>
                      <Clock size={10} style={{ marginRight: 3 }} />{freqLabel[tpl.frequency]}
                    </Badge>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button onClick={() => toast('Шаблон отредактирован', 'success')} style={{ padding: '5px 10px', borderRadius: 6, border: '1px solid #E5E7EB', background: '#fff', cursor: 'pointer', fontSize: 12, color: '#6B7280' }}>Редакт.</button>
                  <button onClick={() => toast('Шаблон удалён', 'warning')} style={{ padding: '5px 10px', borderRadius: 6, border: '1px solid #FEE2E2', background: '#FFF0F0', cursor: 'pointer', fontSize: 12, color: '#FF3B30' }}>Удалить</button>
                </div>
              </div>

              <div style={{ marginTop: 14, padding: '12px', background: '#F8F9FB', borderRadius: 8 }}>
                <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
                  <Users size={12} /><strong>Автоназначение:</strong>
                </div>
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                  {assignedEmps.map(e => (
                    <span key={e.id} style={{ fontSize: 11, padding: '3px 8px', background: '#fff', borderRadius: 6, border: '1px solid #E5E7EB', color: '#374151' }}>{e.name}</span>
                  ))}
                </div>
              </div>

              <div style={{ marginTop: 12, fontSize: 12, color: '#8E8E93' }}>
                Товаров: <strong style={{ color: '#374151' }}>{tpl.products.length}</strong>
                {tpl.category && <> • Категория: <strong style={{ color: '#374151' }}>{tpl.category}</strong></>}
              </div>

              <button onClick={() => toast(`Задачи из шаблона "${tpl.name}" созданы`, 'success')} style={{
                width: '100%', marginTop: 14, padding: '9px', borderRadius: 8,
                border: '1px solid #4A6CF7', background: '#EEF2FF', color: '#4A6CF7',
                fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
              }}>
                ▶ Применить шаблон сейчас
              </button>
            </div>
          );
        })}
      </div>

      <Modal open={showModal} onClose={() => setShowModal(false)} title="Создать шаблон задачи">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <Input label="Название шаблона" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Ежедневная ОСГ — Молочные" required />
          <Select label="Тип задачи" value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value }))} options={[{ value: 'osg', label: 'ОСГ Проверка' }, { value: 'display', label: 'Выкладка' }]} />
          <Select label="Частота" value={form.frequency} onChange={e => setForm(f => ({ ...f, frequency: e.target.value }))} options={[{ value: 'daily', label: 'Ежедневно' }, { value: 'weekly', label: 'Еженедельно' }, { value: 'monthly', label: 'Ежемесячно' }]} />
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 8 }}>
            <Button variant="secondary" onClick={() => setShowModal(false)}>Отмена</Button>
            <Button onClick={() => { toast('Шаблон создан', 'success'); setShowModal(false); }}>Создать</Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
